export {  GlobalHeader } from './GlobalHeader'
export { default as RouteComponent } from './RouteComponent'


// WEBPACK FOOTER //
// ./src/layouts/components/index.ts